const orderDetailsTypes = {
  getWorkOrderData: '[WorkOrder] get work order data',
  openEditVehicleModal: '[WorkOrder] open edit vehicle modal',
  openDeclineConfirm: '[WorkOrder] openDeclineConfirm',
  closeDeclineConfirm: '[WorkOrder] closeDeclineConfirm',
  resetSurveySentStatus: '[WorkOrder] reset survey sent status',
  openModalQualitySurvey: '[WorkOrder] open Modal Quality Survey',
  closeModalQualitySurvey: '[WorkOrder] close Modal Quality Survey',
  hideCancelConfirmationSnackBar:
    '[WorkOrder] hide cancel confirmation snackBar',
  openAddServiceModal: '[WorkOrder] open add service modal',
  closeAddServiceModal: '[WorkOrder] close add service modal',
  closeDeleteConfirmationModal:
    '[WorkOrder] close close delete confirmation modal',
  closeEditVehicleModal: '[WorkOrder] close edit vehicle modal',
  editVehicleDetails: '[WorkOrder] Edit vehicle details',
  deleteService: '[WorkOrder] delete service',
  getServices: '[WorkOrder] get services',
  addServiceToWorkOrder: '[WorkOrder] add service to WorkOrder',
  getWorkOrderToPdf: '[WorkOrder] to pdf',
  cancelStepStatusChange: '[WorkOrder] cancel step status change',
  setPromiseDate: '[WorkOrder] set promise date',
  addSurvey: '[WorkOrder] add survey',
  addWorkOrderNote: '[WorkOrder] AddWorkOrderNote',
  approveOrder: '[WorkOrder] approveOrder',
  declineOrder: '[WorkOrder] declineOrder',
  clearPromiseDateStatus: '[WorkOrder] clear promise date status',
  clearAddServiceError: '[WorkOrder] clear add service error',
};

export default orderDetailsTypes;
